import axios from "axios";
import {apiUrl} from './api';

export default axios.create({
    baseURL:
    apiUrl
});